import {
  CentraCheckoutApiMappers,
  defaultCentraCheckoutApiMappers,
} from "@made-people/grease-centra";
import { mmProductExtraAttributes } from "./mm-product-extra-attributes";
import { mmProductMedia } from "./mm-product-media";
import { mmProductBadges } from "./mm-product-badges";
import { mmProductVariantDimensions } from "./mm-product-variant-dimensions";
import { mmLineItem } from "./mm-line-item";
import { mmProductBase } from "./mm-product-base";
import { mmPurchaseInfo } from "./mm-purchase-info";
import { mmCartTotals } from "./mm-cart-totals";
import { mmOrderTotals } from "./mm-order-totals";
import { mmCodeVoucher } from "./mm-code-voucher";

export const mmCentraMappers: CentraCheckoutApiMappers = {
  ...defaultCentraCheckoutApiMappers,
  centraCheckoutApiProductToGreaseProductExtraAttributes:
    mmProductExtraAttributes,
  centraCheckoutApiProductToGreaseProductMedia: mmProductMedia,
  centraCheckoutApiProductToGreaseProductBadges: mmProductBadges,
  centraCheckoutApiProductItemToGreaseProductVariantDimensions:
    mmProductVariantDimensions,
  centraSelectionItemToGreaseLineItem: mmLineItem,
  centraCheckoutApiProductToGreaseProductBase: mmProductBase,
  centraCheckoutApiItemToGreasePurchaseInfo: mmPurchaseInfo,
  centraSelectionToGreaseCartTotals: mmCartTotals,
  centraCheckoutApiOrderTotalsToGreaseOrderTotals: mmOrderTotals,
  centraCheckoutApiVoucherToGreaseCodeVoucher: mmCodeVoucher,
};
